import React, { Component } from "react";
import clsx from "clsx";
import SocialChangeDetails from "./../../components/SocialBoards/SocialChangeDetails.js";

import {
  BarChart,
  Bar,
  Tooltip,
  ResponsiveContainer,
  YAxis,
  Cell,
  CartesianGrid,
} from "recharts";

import {
  selectFormat,
  MAIN_COLORS,
  CustomizedYAxisTick,
  StandardTooltip,
} from "./../Utils/Utils.js";

class BarChartLegendsMetric extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderBars = (data) => {
    let bars = [];

    data
      .map((e) => Object.keys(e)[0])
      .forEach((bar, i) => {
        bars.push(
          <Bar
            key={i}
            dataKey={bar}
            fill={MAIN_COLORS[i]}
            barSize={125}
            cursor="pointer"
          />
        );
      });

    return bars;
  };

  legendElement = (data) => {
    return data.map((entry, i) => {
      return (
        <span key={i} className="legend mt-2 mt-md-0">
          <span
            className="legend__icon"
            style={{ background: MAIN_COLORS[i] }}
          ></span>
          <span className="legend__text" style={{ color: MAIN_COLORS[i] }}>
            {entry}
          </span>
        </span>
      );
    });
  };

  renderLegends = (data) => {
    let legends = data.map((e) => e.name);

    return <div> {this.legendElement(legends)} </div>;
  };

  prepareData = (data) => {
    return data
      .sort((a, b) => a.value - b.value)
      .map((e, idx) => {
        return {
          ...e,
          idx,
        };
      });
  };

  getExportData = () => ({
    data: this.props.data,
    opts: {
      type: "other",
    },
  });

  render() {
    let { data } = this.props;
    data = this.prepareData(data.data);
    const data_summary = this.props.data.data_summary;

    return (
      <div>
        <div>
          {this.renderLegends(data)}
          <ResponsiveContainer height={400} width="100%">
            <BarChart
              data={data}
              margin={{ top: 12, right: 0, bottom: 25, left: -38 }}
            >
              <CartesianGrid
                stroke="#FEE5DE"
                strokeDasharray="3 3"
                vertical={false}
              />

              <Bar dataKey={"followers_gained"}>
                {data.map((entry, index) => (
                  <Cell fill={MAIN_COLORS[index]} key={`cell-${index}`} />
                ))}
              </Bar>
              <Tooltip
                cursor={{ fill: "#eee", opacity: 0.5 }}
                content={
                  <StandardTooltip
                    render={({ data }) => {
                      const payload = data(this.props);

                      if (payload !== null) {
                        const tooltip_data = payload[0].payload;
                        return (
                          <div className="standard-tooltip">
                            <header className="standard-tooltip__header">
                              <span className="standard-tooltip__key-header">
                                {tooltip_data.name}
                              </span>
                            </header>
                            <main className="standard-tooltip__main">
                              <div className="standard-tooltip__item">
                                <span
                                  className="standard-tooltip__icon"
                                  style={{
                                    background: MAIN_COLORS[tooltip_data.idx],
                                  }}
                                ></span>
                                <span
                                  className={clsx(
                                    "standard-tooltip__key",
                                    "text-capitalize"
                                  )}
                                  style={{
                                    color: MAIN_COLORS[tooltip_data.idx],
                                  }}
                                >
                                  {tooltip_data.name}{" "}
                                </span>
                                <span className="standard-tooltip__value">
                                  {selectFormat(
                                    "number",
                                    tooltip_data.followers_gained
                                  )}
                                </span>
                              </div>
                            </main>
                          </div>
                        );
                      }
                    }}
                  />
                }
              />

              <YAxis
                axisLine={false}
                tickLine={false}
                tickFormatter={(d) => selectFormat("number", d)}
                tick={<CustomizedYAxisTick />}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="d-flex justify-content-center">
          <SocialChangeDetails {...data_summary} />
        </div>
      </div>
    );
  }
}

export default BarChartLegendsMetric;
